import React, { useState } from 'react';
import { CheckIcon, DownloadIcon, LockIcon, RefreshCwOffIcon, ShieldCheckIcon, StarIcon, ZapIcon } from 'lucide-react';
import { Container } from './Container';
import { Button } from './Button';
import { Countdown } from './Countdown';
import { PaymentIcons } from './PaymentIcons';
import { galleryImages } from '../data/content';
const bullets = ['1,200+ printable 3D crafts', 'Instant digital access', 'Print your favorites again and again', 'No subscription', 'Lifetime access'];
const trustItems = [{
  icon: DownloadIcon,
  label: 'Instant digital delivery'
}, {
  icon: LockIcon,
  label: 'Secure payment'
}, {
  icon: ShieldCheckIcon,
  label: '7-day guarantee'
}, {
  icon: RefreshCwOffIcon,
  label: 'No subscription'
}];
export function PurchaseSection() {
  const [activeImage, setActiveImage] = useState(0);
  return <section id="buy" aria-labelledby="buy-heading" className="bg-paper py-16 sm:py-24" data-id="element-155" data-mp="3ss2nd8txp6o9">
      <Container data-id="element-156" data-mp="3oqqxr3b28lg2">
        <div className="overflow-hidden rounded-xl2 border border-hairline bg-white shadow-lift" data-id="element-157" data-mp="y5v5ew5kdrgy">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-158" data-mp="127gq33ocba1p">
            {/* GALLERY */}
            <div className="p-4 sm:p-6 lg:p-8" data-id="element-159" data-mp="1299u0b7kjg60">
              <div className="overflow-hidden rounded-card border border-hairline bg-paper" data-id="element-160" data-mp="175i3p92zyh5s">
                <img src={galleryImages[activeImage].src} alt={galleryImages[activeImage].alt} className="aspect-square w-full object-cover" data-id="element-161" data-mp="1c6nzxgvv8mk2" />
              </div>

              <ul className="mt-3 grid grid-cols-4 gap-2.5" data-id="element-162" data-mp="1l4hwmsxjli7r">
                {galleryImages.map((image, index) => <li key={image.src} data-id="element-163" data-mp="1pzdo9ryva3kc" data-mpi={index}>
                    <button type="button" onClick={() => setActiveImage(index)} aria-pressed={index === activeImage} aria-label={`Show ${image.label} image`} className={`focus-ring block w-full overflow-hidden rounded-[12px] border-2 bg-paper transition-colors ${index === activeImage ? 'border-ink' : 'border-transparent ring-1 ring-hairline hover:ring-muted/30'}`} data-id="element-164" data-mp="1uwduc2vpv6bg">
                      <img src={image.src} alt="" loading="lazy" className="aspect-square w-full object-cover" data-id="element-165" data-mp="1k4zdfcffgxm8" />
                    </button>
                  </li>)}
              </ul>
            </div>

            {/* PRODUCT INFO */}
            <div className="border-t border-hairline p-5 sm:p-7 lg:border-l lg:border-t-0 lg:p-10" data-id="element-166" data-mp="22vqvd2dhdwc8">
              <div className="flex flex-wrap items-center gap-x-2 gap-y-1" data-id="element-167" data-mp="dgsr180abx5v">
                <span className="flex items-center gap-0.5" aria-hidden="true" data-id="element-168" data-mp="diwy1ythdcad">
                  {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-4 w-4 fill-sun text-sun" data-id="element-169" data-mp="2k4jf1cvmwgkj" />)}
                </span>
                <span className="text-[14px] font-semibold text-ink" data-id="element-170" data-mp="2p34h7hug5abm">4.8/5</span>
                <span className="text-[14px] text-muted" data-id="element-171" data-mp="2afrsxld98qhj">Loved by creative families</span>
              </div>

              <h2 id="buy-heading" className="mt-4 font-display text-[30px] font-bold leading-[1.12] tracking-[-0.02em] text-ink sm:text-[36px]" data-id="element-172" data-mp="2fdkzifigzmic">
                3D Paper Craft Mega Kit
              </h2>
              <p className="mt-2 text-[17px] text-muted" data-id="element-173" data-mp="25du142qsgncz">1,200+ Printable 3D Projects</p>

              <div className="mt-6 flex flex-wrap items-center gap-x-3 gap-y-2" data-id="element-174" data-mp="1rii7xzsa74y6">
                <span className="font-display text-[36px] font-bold leading-none tracking-[-0.025em] text-ink" data-id="element-175" data-mp="1wg0gvq6atk66">
                  $19.99
                </span>
                <span className="text-[18px] text-muted line-through" data-id="element-176" data-mp="3qu1fqb1um769">$39.99</span>
                <span className="rounded-[8px] bg-flame px-2.5 py-1 font-display text-[12px] font-extrabold uppercase tracking-[0.08em] text-white" data-id="element-177" data-mp="1qr08z99ky0vg">
                  50% Off
                </span>
              </div>
              <p className="mt-2.5 font-display text-[12px] font-semibold uppercase tracking-[0.2em] text-muted" data-id="element-178" data-mp="1hq2bzaxk6tmd">
                One-time payment
              </p>

              <ul className="mt-7 space-y-3" data-id="element-179" data-mp="1cttqzgwok67a">
                {bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-180" data-mp="17uh44w5t6z4p">
                    <span aria-hidden="true" className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-goSoft" data-id="element-181" data-mp="1304lupg2jtuj">
                      <CheckIcon className="h-3 w-3 text-goDark" data-id="element-182" data-mp="u2kjteadttiv" />
                    </span>
                    <span className="text-[16px] leading-[1.5] text-inkSoft sm:text-[17px]" data-id="element-183" data-mp="p1da39ooik9k">
                      {bullet}
                    </span>
                  </li>)}
              </ul>

              <div className="mt-7 rounded-card border border-hairline bg-paper px-4 py-4" data-id="element-184" data-mp="2vpx6ejymy18h">
                <p className="font-display text-[12px] font-bold uppercase tracking-[0.16em] text-ink" data-id="element-185" data-mp="30nox5anjnhb3">
                  100% Digital Product
                </p>
                <p className="mt-1.5 text-[15px] leading-[1.5] text-muted" data-id="element-186" data-mp="39q7xno3uxhu6">
                  Nothing will be shipped to your home.
                </p>
              </div>

              <div className="mt-7 flex items-center justify-center gap-2 rounded-[12px] bg-alertSoft px-3 py-3 text-center" data-id="element-187" data-mp="2hys1p3geuira">
                <span aria-hidden="true" data-id="element-188" data-mp="2m03u1gqo5i36">🔥</span>
                <span className="font-display text-[13px] font-extrabold uppercase tracking-[0.1em] text-[#B91C1C]" data-id="element-189" data-mp="2ly975wvu7fwg">
                  Launch offer — 50% off today
                </span>
              </div>

              <div className="mt-3" data-id="element-190" data-mp="1u7d75wuvl5ql">
                <Button variant="go" data-id="element-191" data-mp="1ya9lhbddufoq">Get Instant Access</Button>
              </div>

              <div className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-1.5 text-[14px] text-muted" data-id="element-192" data-mp="31lfaf4n57qwq">
                <span className="flex items-center gap-1.5" data-id="element-193" data-mp="2wndpee65phim">
                  <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-194" data-mp="3bbibls4f4b65" /> Secure checkout
                </span>
                <span className="flex items-center gap-1.5" data-id="element-195" data-mp="36cf84c436d0a">
                  <ZapIcon className="h-4 w-4" aria-hidden="true" data-id="element-196" data-mp="36d71dga7nyne" /> Instant access after purchase
                </span>
              </div>

              <div className="mt-5" data-id="element-197" data-mp="2dnzr5k1e9kmb">
                <PaymentIcons data-id="element-198" data-mp="2dp1furbc25mi" />
              </div>

              <div className="mt-7" data-id="element-199" data-mp="2rnj18idrn619">
                <Countdown data-id="element-200" data-mp="2rokachb81igc" />
              </div>

              <ul className="mt-7 grid grid-cols-2 gap-x-4 gap-y-3.5 border-t border-hairline pt-7" data-id="element-201" data-mp="2rl695ceanfah">
                {trustItems.map(item => <li key={item.label} className="flex items-start gap-2.5 text-[14px] text-muted sm:text-[15px]" data-id="element-202" data-mp="6w8rufqr01ap">
                    <item.icon className="mt-0.5 h-4 w-4 flex-none text-go" aria-hidden="true" data-id="element-203" data-mp="2ux0o5s8780e" />
                    {item.label}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </Container>
    </section>;
}